/*!
 * vue-eq v0.10.8 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { EqObserver, EQ_DEFAULT_BREAKPOINTS } from '@aspectus/eq';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var EQ_EVENT_UPDATE = 'eq:update';
var EQ_EVENT_UNBIND = 'eq:unbind';
var Directive =
/*#__PURE__*/
function () {
  function Directive(_ref) {
    var _ref$breakpoints = _ref.breakpoints,
        breakpoints = _ref$breakpoints === void 0 ? [] : _ref$breakpoints;

    _classCallCheck(this, Directive);

    this.breakpoints = breakpoints;
    this.bind = this.bind.bind(this);
    this.update = this.update.bind(this);
    this.unbind = this.unbind.bind(this);
  }

  _createClass(Directive, [{
    key: "bind",
    value: function bind(el, _ref2) {
      var value = _ref2.value;
      var breakpoints = Array.isArray(value) ? value : this.breakpoints || [];
      var observer = new EqObserver({
        breakpoints: breakpoints
      }).bind(el);

      var updator = function updator(e) {
        observer.update({
          breakpoints: e.detail.breakpoints || []
        });
      };

      var unbinder = function unbinder() {
        observer.unbind(el);
        observer.clear();
        el.removeEventListener(EQ_EVENT_UPDATE, updator);
        el.removeEventListener(EQ_EVENT_UNBIND, unbinder);
      };

      el.addEventListener(EQ_EVENT_UPDATE, updator);
      el.addEventListener(EQ_EVENT_UNBIND, unbinder);
    }
  }, {
    key: "update",
    value: function update(el, _ref3) {
      var value = _ref3.value;
      var breakpoints = Array.isArray(value) && value || this.breakpoints || [];
      el.dispatchEvent(new CustomEvent(EQ_EVENT_UPDATE, {
        detail: {
          breakpoints: breakpoints
        }
      }));
    }
  }, {
    key: "unbind",
    value: function unbind(el) {
      el.dispatchEvent(new CustomEvent(EQ_EVENT_UNBIND));
    }
  }]);

  return Directive;
}();

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'eq' : _ref$name,
      _ref$defaultBreakpoin = _ref.defaultBreakpoints,
      defaultBreakpoints = _ref$defaultBreakpoin === void 0 ? EQ_DEFAULT_BREAKPOINTS : _ref$defaultBreakpoin;

  Vue.directive(name, new Directive({
    breakpoints: defaultBreakpoints
  }));
}

export default install;
export { Directive, EQ_EVENT_UNBIND, EQ_EVENT_UPDATE, install };
